import Model from './Model'
import Payment from './Payment'
import Contract from './Contract'
export default class Customer extends Model {

    resource()
    {
        return 'customers'
    }

    payments() {
        return this.hasMany(Payment)
    }

    contracts() {
        return this.hasMany(Contract)
    }
}
